/*
 * A utility class for conditional logging in development mode.
 * Console messages will only appear when enviroment is in development.
 * The command "gatsby develop" command sets NODE_ENV to "development".
 * The command "gatsby build" command sets NODE_ENV to "production".
 * https://v2.gatsbyjs.com/docs/how-to/local-development/environment-variables/
 */

if (process.env.NODE_ENV === "development") {
    module.exports = {
        log: (...args) => console.log(...args),
        warn: (...args) => console.warn(...args),
        error: (...args) => console.error(...args)
    }
} else {
    module.exports = {
        log: (...args) => {},
        warn: (...args) => {},
        error: (...args) => {}
    }
}
